document.addEventListener('DOMContentLoaded', () => {
  initMatsuFV();
  initMatsuInview();
});

function initMatsuFV() {
  const roots = document.querySelectorAll('[data-matsu-fv]');
  if (!roots.length) return;

  const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

  roots.forEach((root) => {
    const en = root.querySelector('.matsu-fv-story__sub--en');
    const jp = root.querySelector('.matsu-fv-story__sub--jp');
    if (!en || !jp) return;

    const render = () => {
      const rect = root.getBoundingClientRect();
      const total = root.offsetHeight - window.innerHeight;
      const scrolled = clamp(-rect.top, 0, total);
      const progress = total > 0 ? scrolled / total : 0;

      en.classList.remove('is-active');
      jp.classList.remove('is-active');

      if (progress < 0.33) {
        en.classList.add('is-active');
      } else {
        jp.classList.add('is-active');
      }
    };

    window.addEventListener('load', () => {
      requestAnimationFrame(() => {
        root.classList.add('is-loaded');
        render();
      });
    });

    render();
    window.addEventListener('scroll', render, { passive: true });
    window.addEventListener('resize', render);
  });
}

function initMatsuInview() {
  const targets = document.querySelectorAll('[data-matsu-inview]');
  if (!targets.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview');
      }
    });
  }, {
    root: null,
    threshold: 0.25,
    rootMargin: '0px 0px -10% 0px'
  });

  targets.forEach((target) => io.observe(target));
}